/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type image_picture$ref: FragmentReference;
declare export opaque type image_picture$fragmentType: image_picture$ref;
export type image_picture = {|
  +nameId: ?string,
  +extension: ?string,
  +predictName: ?string,
  +$refType: image_picture$ref,
|};
export type image_picture$data = image_picture;
export type image_picture$key = {
  +$data?: image_picture$data,
  +$fragmentRefs: image_picture$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "image_picture",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "extension",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "predictName",
      "storageKey": null
    }
  ],
  "type": "Picture",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'b039bd31bbd28ca866c0c4355c72ce8a';

module.exports = node;
